import apiClient from './apiClient';

// ============================================================
// Types — matching backend Go models for M301 (總庫存量表)
// ============================================================

/**
 * ReportRequest mirrors FoxPro pwm301f1 criteria form + backend SearchParams.
 */
export interface ReportRequest {
  warehouseFrom?: string;    // FM030_01 庫位起始
  warehouseTo?: string;      // FM030_01 庫位結束
  productFrom?: string;      // FM030_02 產品起始 (12 chars, 6+6 split)
  productTo?: string;        // FM030_02 產品結束
  batchFrom?: string;        // FM030_03 批號起始
  batchTo?: string;          // FM030_03 批號結束
  dateFrom?: string;         // FM030_13 入庫日期起始 YYYY-MM-DD
  dateTo?: string;           // FM030_13 入庫日期結束 YYYY-MM-DD
  includeZeroStock?: boolean; // OptZERO: true (=1 包含零庫存) / false (=2 排除零庫存)
}

/** Legacy listing item — still supported but deprecated. */
export interface ReportItem {
  fm030_01: string;          // 庫位
  fm030_02: string;          // 產品
  fm030_03: string;          // 批號
  fm030_12: string;          // 單位
  fm030_13: string | null;   // 入庫日
  fm030_16: number;          // 庫存量
  fm030_17: number;          // 庫存金額
  fm030_18: number;          // 平均單價
  fm030_51: string;          // 色號
  loc_name: string;          // 庫位名稱
  color_name: string;        // 色號名稱
}

export interface ReportResponse {
  items: ReportItem[];
  total: number;
}

// ============================================================
// API methods
// ============================================================

export const m301Api = {
  /**
   * (Deprecated) Query flat inventory rows via GET.
   * Kept for backward compatibility with any code that still reads rows in-page.
   * Use `print()` for the FoxPro-faithful PDF report instead.
   */
  async getReport(params: ReportRequest): Promise<ReportResponse> {
    const query: Record<string, string> = {};
    if (params.warehouseFrom?.trim()) query['warehouseFrom'] = params.warehouseFrom.trim();
    if (params.warehouseTo?.trim()) query['warehouseTo'] = params.warehouseTo.trim();
    if (params.productFrom?.trim()) query['productFrom'] = params.productFrom.trim();
    if (params.productTo?.trim()) query['productTo'] = params.productTo.trim();
    if (params.batchFrom?.trim()) query['batchFrom'] = params.batchFrom.trim();
    if (params.batchTo?.trim()) query['batchTo'] = params.batchTo.trim();
    if (params.dateFrom?.trim()) query['dateFrom'] = params.dateFrom.trim();
    if (params.dateTo?.trim()) query['dateTo'] = params.dateTo.trim();
    if (params.includeZeroStock) query['includeZeroStock'] = 'true';
    const res = await apiClient.get('/api/m301/report', { params: query });
    return res.data;
  },

  /**
   * Produce the PWM301P1 PDF report. Mirrors FoxPro Pwtcmdp1.Command3.Click path.
   * Returns the raw PDF blob (caller should URL.createObjectURL + window.open).
   */
  async print(params: ReportRequest): Promise<Blob> {
    const body: ReportRequest = {
      warehouseFrom: params.warehouseFrom?.trim() || '',
      warehouseTo: params.warehouseTo?.trim() || '',
      productFrom: params.productFrom?.trim() || '',
      productTo: params.productTo?.trim() || '',
      batchFrom: params.batchFrom?.trim() || '',
      batchTo: params.batchTo?.trim() || '',
      dateFrom: params.dateFrom?.trim() || '',
      dateTo: params.dateTo?.trim() || '',
      includeZeroStock: params.includeZeroStock ?? false,
    };
    const res = await apiClient.post('/api/m301/print', body, { responseType: 'blob' });
    return res.data;
  },
};
